import type { ReactNode } from 'react';
import aiGlow from '../../assets/auth/ai-glow.svg';
import { Logo } from '../brand/Logo';

type AuthLayoutProps = {
  topRight?: ReactNode;
  children: ReactNode;
};

export function AuthLayout({ topRight, children }: AuthLayoutProps) {
  return (
    <div className="flex min-h-screen w-full bg-bg-canvas">
      <aside className="relative hidden w-full max-w-[610px] shrink-0 overflow-hidden bg-bg-navigation lg:block">
        <img
          src={aiGlow}
          alt=""
          className="pointer-events-none absolute -top-[120px] left-[35%] w-[520px] max-w-none"
        />
        <div className="relative z-10 flex h-full flex-col px-12 py-10">
          <Logo variant="dark" size={26} />

          <div className="mt-40">
            <p className="text-[11px] font-semibold tracking-wide text-ai-accent">
              ЕДИНОЕ ГЕОПРОСТРАНСТВО
            </p>
            <h1 className="mt-4 text-4xl font-semibold leading-tight text-text-inverse">
              Управляйте территорией
              <br />
              на основе данных и ИИ
            </h1>
            <p className="mt-6 text-base leading-relaxed text-text-inverse/90">
              Карты, объекты, отчёты и процессы
              <br />
              в защищённом рабочем пространстве.
            </p>
          </div>

          <div className="mt-8 flex flex-1 flex-col justify-center gap-4">
            <p className="text-[11px] font-semibold uppercase tracking-wide text-text-inverse/40">
              Правовой статус
            </p>

            <a
              href="https://reestr.digital.gov.ru/reestr/12838281/?sphrase_id=24814861"
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-between rounded-xl border border-white/15 bg-white/5 px-5 py-5 hover:bg-white/10"
            >
              <div className="flex items-center gap-2.5">
                <span className="size-1.5 shrink-0 rounded-full bg-status-success" />
                <div>
                  <p className="text-sm font-semibold text-text-inverse">Реестр российского ПО</p>
                  <p className="mt-0.5 text-[11px] text-text-inverse/60">Запись № 34163</p>
                </div>
              </div>
              <span className="shrink-0 text-text-inverse/40">→</span>
            </a>

            <div className="flex items-center gap-2.5 rounded-xl border border-white/15 bg-white/5 px-5 py-5">
              <span className="size-1.5 shrink-0 rounded-full bg-status-success" />
              <div>
                <p className="text-sm font-semibold text-text-inverse">Права на ЭВМ</p>
                <p className="mt-0.5 text-[11px] text-text-inverse/60">
                  Свидетельство о государственной регистрации программы для ЭВМ
                </p>
              </div>
            </div>

            <a
              href="https://geoinfo.xenus.dev/#documentation"
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-between rounded-xl border border-white/15 bg-white/5 px-5 py-5 hover:bg-white/10"
            >
              <p className="text-sm font-semibold text-text-inverse">Документация</p>
              <span className="shrink-0 text-text-inverse/40">→</span>
            </a>

            <a
              href="https://geoinfo.xenus.dev/"
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-between rounded-xl border border-white/15 bg-white/5 px-5 py-5 hover:bg-white/10"
            >
              <p className="text-sm font-semibold text-text-inverse">Официальный сайт КСЕНУС ГИС</p>
              <span className="shrink-0 text-text-inverse/40">→</span>
            </a>
          </div>
        </div>
      </aside>

      <main className="relative flex flex-1 flex-col">
        {topRight && <div className="absolute right-10 top-11 text-xs">{topRight}</div>}
        <div className="flex flex-1 items-center justify-center px-6 py-16">
          <div className="w-full max-w-[630px]">{children}</div>
        </div>
      </main>
    </div>
  );
}
